import { render, staticRenderFns } from "./importModal.vue?vue&type=template&id=46bf80e6&scoped=true"
import script from "./importModal.vue?vue&type=script&lang=js"
export * from "./importModal.vue?vue&type=script&lang=js"
import style0 from "./importModal.vue?vue&type=style&index=0&id=46bf80e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf80e6",
  null
  
)

export default component.exports